/*
  KFA CONSENT BANNER — V19
  Robust preview detection + Shopify Customer Privacy API

  Preview is forced when any of these are present:
  - ?kfa_consent_preview=1
  - Shopify theme preview URL with ?preview_theme_id=...
  The preview state is kept in sessionStorage while the preview tab remains open.
*/
(function () {
  'use strict';

  var BANNER_ID = 'kfa-consent-banner';
  var BTN_ACCEPT_ID = 'kfa-btn-accept';
  var BTN_DECLINE_ID = 'kfa-btn-decline';
  var PREVIEW_PARAM = 'kfa_consent_preview';
  var PREVIEW_SESSION_KEY = 'kfa_consent_preview_active';
  var FIRST_PARTY_CONSENT_KEY = 'kfa_consent_choice_v1';
  var ACTION_DELAY_MS = 3400;
  var MOBILE_ACTION_DELAY_MS = 850;
  var bound = false;
  var actionTimer = null;
  var initialized = false;

  function signalDecisionNeeded() {
    var banner = el(BANNER_ID);
    if (!banner || banner.hasAttribute('hidden')) return;

    /* The focus line remains active until either privacy choice is made. */
    banner.classList.add('kfa-consent-needs-attention');
    document.documentElement.classList.add('kfa-consent-needs-attention');
  }

  function setDecisionGate(active, banner) {
    var root = document.documentElement;

    try {
      window.clearTimeout(window.__kfaConsentSafetyTimer);
    } catch (e) {}

    root.classList.remove('kfa-consent-checking');
    root.classList.toggle('kfa-consent-decision-required', Boolean(active));

    if (banner) {
      banner.setAttribute('aria-modal', active ? 'true' : 'false');
    }
  }

  function el(id) {
    return document.getElementById(id);
  }

  function consentHost(banner) {
    return banner && banner.closest ? banner.closest('.portal__right') : null;
  }

  function releasePortalLink(banner, animate) {
    setDecisionGate(false, banner);
    var host = consentHost(banner);
    if (!host) return;

    var portalSection = host.closest('section.okd-portal');
    if (portalSection) {
      portalSection.classList.remove('kfa-mobile-consent-active');
      portalSection.classList.remove('kfa-consent-veil-active');
      portalSection.classList.remove('kfa-consent-gate-active');
    }

    var isDesktop = window.matchMedia && window.matchMedia('(min-width: 1025px)').matches;

    /* Desktop post-consent choreography:
       1) remove the cookie composition,
       2) let ATELI'R complete its full reveal,
       3) keep Explore The Ateli'r fully visible for two seconds,
       4) only then reveal Discover XPOSURE.
       Mobile deliberately keeps its existing behaviour unchanged. */
    if (animate && isDesktop) {
      host.classList.remove('kfa-consent-active', 'kfa-consent-resolved');
      host.classList.add('kfa-consent-pending');

      var leftPanel = portalSection ? portalSection.querySelector('.portal__left') : null;
      if (leftPanel) {
        leftPanel.classList.add('kfa-desktop-reveal');
        if (portalSection) portalSection.classList.add('kfa-desktop-reveal');

        var video = leftPanel.querySelector('.portal__left-visual video');
        if (video) {
          try {
            if (Number.isFinite(video.duration)) video.currentTime = 0;
            var playPromise = video.play();
            if (playPromise && typeof playPromise.catch === 'function') {
              playPromise.catch(function () {});
            }
          } catch (e) {}
        }
      }

      /* Desktop CSS starts the ATELI'R link at 4.05 s and fades it for 2.5 s.
         4.05 + 2.5 + 2.0 = 8.55 s before XPOSURE is allowed back in. */
      window.setTimeout(function () {
        host.classList.remove('kfa-consent-pending');
        host.classList.add('kfa-consent-resolved');
      }, 8550);
    } else {
      host.classList.remove('kfa-consent-pending', 'kfa-consent-active');
      if (animate) {
        host.classList.add('kfa-consent-resolved');
      } else {
        host.classList.remove('kfa-consent-resolved');
      }
    }

    try { document.dispatchEvent(new CustomEvent('kfa:consent-resolved')); } catch (e) {}
  }


  function syncDesktopGeometry(banner) {
    if (!banner || !window.matchMedia || !window.matchMedia('(min-width: 1025px)').matches) return;

    var host = banner.closest('.portal__right');
    if (!host) return;

    var visual = host.querySelector('.portal__right-visual');
    if (!visual) return;

    var hostRect = host.getBoundingClientRect();
    var imageRect = visual.getBoundingClientRect();
    if (!hostRect.width || !imageRect.width) return;

    /* Consent geometry follows the actual XPOSURE image, not the wordmark.
       Rails sit symmetrically just outside the image; copy/buttons remain
       exactly inside the image width. */
    var extension = Math.max(18, Math.min(34, imageRect.width * 0.045));
    var left = Math.max(12, (imageRect.left - hostRect.left) - extension);
    var right = Math.max(12, (hostRect.right - imageRect.right) - extension);

    banner.style.setProperty('--kfa-consent-left', left.toFixed(2) + 'px');
    banner.style.setProperty('--kfa-consent-right', right.toFixed(2) + 'px');
    banner.style.setProperty('--kfa-consent-overhang', extension.toFixed(2) + 'px');
  }

  function queryForcesPreview() {
    try {
      var params = new URLSearchParams(window.location.search);
      return (
        params.has(PREVIEW_PARAM) ||
        params.has('preview_theme_id') ||
        params.has('preview_key')
      );
    } catch (e) {
      return false;
    }
  }

  function referrerIsPreview() {
    try {
      return /(?:preview_theme_id|preview_key|kfa_consent_preview)=/i.test(document.referrer || '');
    } catch (e) {
      return false;
    }
  }

  function rememberPreview() {
    try {
      if (queryForcesPreview() || referrerIsPreview()) {
        window.sessionStorage.setItem(PREVIEW_SESSION_KEY, '1');
      }
    } catch (e) {
      /* sessionStorage can be unavailable in strict privacy modes */
    }
  }

  function isPreviewMode() {
    /* Preview state is never persisted across routes. */

    return queryForcesPreview();

    try {
      return window.sessionStorage.getItem(PREVIEW_SESSION_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function readFirstPartyChoice() {
    var choice = '';
    try {
      choice = window.localStorage.getItem(FIRST_PARTY_CONSENT_KEY) || '';
    } catch (e) {}
    if (choice !== 'analytics' && choice !== 'essential') {
      try {
        var match = document.cookie.match(new RegExp('(?:^|;\\s*)' + FIRST_PARTY_CONSENT_KEY + '=([^;]*)'));
        choice = match ? decodeURIComponent(match[1]) : '';
      } catch (e) {
        choice = '';
      }
    }
    return choice === 'analytics' || choice === 'essential' ? choice : '';
  }

  function storeFirstPartyChoice(analyticsValue) {
    var choice = analyticsValue ? 'analytics' : 'essential';
    try { window.localStorage.setItem(FIRST_PARTY_CONSENT_KEY, choice); } catch (e) {}
    try {
      document.cookie = FIRST_PARTY_CONSENT_KEY + '=' + encodeURIComponent(choice) +
        '; Max-Age=15552000; Path=/; SameSite=Lax; Secure';
    } catch (e) {}
  }

  function getApi() {
    return window.Shopify && window.Shopify.customerPrivacy
      ? window.Shopify.customerPrivacy
      : null;
  }

  function hasDecision() {
    if (readFirstPartyChoice()) return true;
    var api = getApi();
    if (!api) return false;

    try {
      var consent = api.getTrackingConsent();

      if (typeof consent === 'string') {
        return consent !== 'no_interaction';
      }

      return Boolean(
        consent &&
        typeof consent === 'object' &&
        consent.analytics !== 'no_interaction'
      );
    } catch (e) {
      return false;
    }
  }

  function inConsentRegion() {
    var api = getApi();
    if (!api) return false;

    try {
      if (typeof api.shouldShowBanner === 'function') {
        return Boolean(api.shouldShowBanner());
      }

      if (typeof api.userCanBeTracked === 'function') {
        return !api.userCanBeTracked();
      }

      return true;
    } catch (e) {
      return true;
    }
  }

  function shouldDisplay() {
    if (isPreviewMode()) return true;

    /* The KFA choice is a one-time, site-wide gate. Do not let a delayed or
       unavailable Shopify privacy API bypass the decision on a direct entry
       page. A previously stored KFA or Shopify decision still suppresses the
       banner everywhere. */
    return !hasDecision();
  }

  /* Consent gate: capture at WINDOW level so this runs before every theme
     handler. Until the visitor has chosen, no page control behind the banner
     may navigate, submit or activate. Banner controls remain interactive. */
  function blockPageInteraction(event) {
    if (!document.documentElement.classList.contains('kfa-consent-decision-required')) return;

    var target = event.target;
    if (target && target.closest && target.closest('#' + BANNER_ID)) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    signalDecisionNeeded(false);
  }

  ['pointerdown', 'mousedown', 'touchstart', 'click', 'auxclick', 'submit'].forEach(function (type) {
    window.addEventListener(type, blockPageInteraction, true);
  });

  window.addEventListener('keydown', function (event) {
    if (!document.documentElement.classList.contains('kfa-consent-decision-required')) return;

    var banner = el(BANNER_ID);
    if (!banner) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }

    if (event.key !== 'Tab') {
      if (!banner.contains(event.target)) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
      return;
    }

    var focusable = banner.querySelectorAll('button:not([disabled]), a[href], details > summary');
    if (!focusable.length) {
      event.preventDefault();
      return;
    }

    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    } else if (!banner.contains(document.activeElement)) {
      event.preventDefault();
      first.focus();
    }
  }, true);

  function reveal(banner) {
    if (!banner) return;

    setDecisionGate(true, banner);

    var host = consentHost(banner);
    if (host) {
      host.classList.remove('kfa-consent-pending', 'kfa-consent-resolved');
      host.classList.add('kfa-consent-active');
      var portalSection = host.closest('section.okd-portal');
      if (portalSection) {
        portalSection.classList.add('kfa-mobile-consent-active');
        portalSection.classList.add('kfa-consent-veil-active');
        portalSection.classList.add('kfa-consent-gate-active');
      }
    }

    banner.removeAttribute('hidden');
    syncDesktopGeometry(banner);
    window.requestAnimationFrame(function () { syncDesktopGeometry(banner); });

    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        banner.classList.add('is-copy-visible');
      });
    });

    window.clearTimeout(actionTimer);
    var delay = window.matchMedia && window.matchMedia('(max-width: 720px)').matches
      ? MOBILE_ACTION_DELAY_MS
      : ACTION_DELAY_MS;

    actionTimer = window.setTimeout(function () {
      banner.classList.add('is-actions-visible');
      signalDecisionNeeded(true);
    }, delay);
  }

  function hideBanner() {
    var banner = el(BANNER_ID);
    if (!banner) return;

    window.clearTimeout(actionTimer);
    banner.classList.remove('kfa-consent-needs-attention');
    document.documentElement.classList.remove('kfa-consent-needs-attention');
    setDecisionGate(false, banner);

    /* Release only the independent visual veil. The portal itself is never
       restyled, moved or filtered by the consent flow. */
    var host = consentHost(banner);
    var portalSection = host && host.closest ? host.closest('section.okd-portal') : null;
    if (portalSection) portalSection.classList.remove('kfa-consent-veil-active');

    banner.classList.remove('is-actions-visible', 'is-copy-visible');
    banner.setAttribute('hidden', '');

    /* Keep the underlying CTA out of the cookie composition. Once the
       decision is complete, bring it back as a separate, quiet final beat. */
    window.setTimeout(function () {
      releasePortalLink(banner, true);
    }, 180);
  }

  function applyConsent(analyticsValue) {
    storeFirstPartyChoice(Boolean(analyticsValue));

    if (isPreviewMode()) {
      hideBanner();
      return;
    }

    var api = getApi();
    if (!api || typeof api.setTrackingConsent !== 'function') {
      hideBanner();
      return;
    }

    /* Shopify normally acknowledges the choice through its callback. Keep a
       short idempotent fallback so an unavailable callback cannot leave the
       visitor trapped after an explicit Accept or Decline click. */
    var finished = false;
    var finishTimer = null;
    function finish() {
      if (finished) return;
      finished = true;
      window.clearTimeout(finishTimer);
      hideBanner();
    }

    finishTimer = window.setTimeout(finish, 1200);

    try {
      api.setTrackingConsent(
        {
          analytics: analyticsValue,
          preferences: false,
          marketing: false,
          sale_of_data: false
        },
        finish
      );
    } catch (e) {
      finish();
    }
  }

  function bindButtons() {
    if (bound) return;
    bound = true;

    var accept = el(BTN_ACCEPT_ID);
    var decline = el(BTN_DECLINE_ID);

    if (accept) {
      accept.addEventListener('click', function () {
        applyConsent(true);
      });
    }

    if (decline) {
      decline.addEventListener('click', function () {
        applyConsent(false);
      });
    }
  }

  function initBanner() {
    if (initialized) return;

    var banner = el(BANNER_ID);
    if (!banner) return;

    initialized = true;

    if (!shouldDisplay()) {
      releasePortalLink(banner, false);
      return;
    }

    bindButtons();
    reveal(banner);
  }

  function boot() {
    /* Preview state is never persisted across routes. */

    function start() {
      /* Preview must never depend on the Shopify privacy API loading. */
      if (isPreviewMode()) {
        initBanner();
        return;
      }

      if (getApi()) {
        initBanner();
        return;
      }

      document.addEventListener(
        'shopify:consent:ready',
        function onReady() {
          document.removeEventListener('shopify:consent:ready', onReady);
          initBanner();
        }
      );

      /* A delayed second attempt covers asynchronously injected API builds. */
      window.setTimeout(function () {
        if (getApi()) {
          initBanner();
        } else {
          /* The visitor still needs to make the one-time choice even when the
             Shopify API is late or unavailable. applyConsent() persists the
             result locally and syncs it to Shopify whenever the API exists. */
          initBanner();
        }
      }, 1800);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }
  }

  window.addEventListener('resize', function () {
    var banner = el(BANNER_ID);
    if (banner && !banner.hasAttribute('hidden')) syncDesktopGeometry(banner);
  }, { passive: true });

  boot();
})();
